import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/shared/lib/queryKeys";
import { systemProfileService } from "@/entities/user/api/systemProfileService";
import { MAX_FETCH_ALL_SIZE } from "@/shared/config/pagination";

interface UseSuppliersOptions {
    /**
     * Alguns consumidores truncam a lista de propósito (100 em vez de 1000).
     * O valor entra na query key, então cada tamanho tem seu próprio cache.
     */
    size?: number;
    /** Carregamento sob demanda: só busca quando o consumidor precisar. */
    enabled?: boolean;
}

export function useSuppliers({ size = MAX_FETCH_ALL_SIZE, enabled = true }: UseSuppliersOptions = {}) {
    const { data, isFetching, refetch } = useQuery({
        queryKey: queryKeys.suppliers.list(size),
        enabled,
        queryFn: () => systemProfileService.getAll({
            page: 1,
            size,
            filter: { type: "supplier" },
        }),
        staleTime: 15 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
    });

    return {
        // Em erro, `data` fica undefined e a lista sai vazia — mesmo
        // comportamento do try/catch que estes call sites tinham antes,
        // mas preservando retry e estado de erro do próprio TanStack.
        suppliers: data?.content ?? [],
        loadingSuppliers: isFetching,
        refetchSuppliers: refetch,
    };
}
